import {Location} from '@angular/common';
import {map} from 'rxjs/operators';
import {Component, OnInit} from '@angular/core';
import {ApiServiceService} from '../api-service.service';
import {Keys, StorageService} from '../service/storage.service';
import {ReferralService} from '../service/referral.service';
import {LenderDashboardLinkProvider} from '../utils/lenderDashboardLinkProvider';
import {HeaderComponent} from '../header/header.component';
import {MenuItem} from '../header/menu-item';
import {HttpClient} from '@angular/common/http';
import { ConfigService } from '../service/config.service';
import { ReferralSchemeDateRange } from '../model/referral-schmem-date.model';

@Component({
    templateUrl: './referrals.component.html',
    styleUrls: ['./referrals.component.css'],
    providers: [ApiServiceService, StorageService, ReferralService]
})
export class ReferralsComponent implements OnInit {
    finzyDomain = true;
    otherDomain = false;
    showBorrowerSideMenu: boolean = null;
    referralCode: string = null;
    points: number = null;
    raferralDate: ReferralSchemeDateRange;

    dashLink: [string];

    constructor(private referralService: ReferralService, private http: HttpClient, private storageService: StorageService,
                private apiService: ApiServiceService, private lenderDashboardLinkProvider: LenderDashboardLinkProvider, private location: Location) {
    }

    ngOnInit(): void {
        this.raferralDate = ConfigService.referralSchemeDateRange();
        this.showBorrowerSideMenu = !this.storageService.getItem(Keys.LENDER) ||
            HeaderComponent.selectedMenuItem === MenuItem.MyLoans;
        this.fetchReferralCode();
        this.populateDashLink();
        this.populatePartnerData();
    }

    private populatePartnerData() {
        this.otherDomain = this.storageService.getItem('domain') === 'tripfactory';
        this.finzyDomain = !this.otherDomain;
    }

    private async fetchReferralCode() {
        const profileId = this.storageService.getItem(Keys.PROFILE_ID);

        const token = this.storageService.getItem(Keys.TOKEN);
        const referralDetails = await this.referralService.fetchReferralDetails(profileId, token);
        this.referralCode = referralDetails.referralCode;
        this.points = referralDetails.points;
    }

    private populateDashLink() {
        if (!this.storageService.getItem(Keys.LENDER) || HeaderComponent.selectedMenuItem === MenuItem.MyLoans) {
            this.http.post<any>(this.apiService.baseURL() + 'getLoanInfoDetails',
                {
                    loan_id: this.storageService.getItem('loan_id'),
                    profile_id: this.storageService.getItem('profile_id'),
                    token: this.storageService.getItem('token')
                }).subscribe((result2) => {
                    if (result2.status == 'success') {
                        const loan_sanction_status = result2.loan_info.loan_sanction_status;

                        if (loan_sanction_status == 'loan_disbursed' || loan_sanction_status == 'document_hardcopy_recieved') {
                            this.dashLink = ['/borrowerdashboard'];

                        } else if (loan_sanction_status == 'ready_for_kyc' || loan_sanction_status == 'kyc_in_progress' ||
                            loan_sanction_status == 'ready_for_pcd' || loan_sanction_status == 'pcd_in_progress' ||
                            loan_sanction_status == 'ready_for_dcd' || loan_sanction_status == 'dcd_in_progress' ||
                            loan_sanction_status == 'sanctioned' || loan_sanction_status == 'rejected') {

                            this.dashLink = ['/loansanction'];

                        } else if (loan_sanction_status == 'accepted' || loan_sanction_status === 'queued_to_be_fulfilled' ||
                            loan_sanction_status == 'bank_details_filled' ||
                            loan_sanction_status == 'document_verified' || loan_sanction_status == 'ready_for_disbursal' ||
                            loan_sanction_status == 'loan_disbursed_initiated' || loan_sanction_status == 'loan_fulfilled') {

                            this.dashLink = ['/loanprogress'];
                        }
                    }
                });
        } else {
            this.lenderDashboardLinkProvider.getDashboardLink().then(link => {
                this.dashLink = [link];
            });
        }
    }

    backToPreviousPage() {
        this.location.back();
    }
}
